module.exports = __webpack_public_path__ + "images/emoji/leopard.90b93e06ce00982a7947.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/leopard.png
// module id = 3uwo
// module chunks = 2